import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { TransactionSearchOrder } from '@/globalTypes';
import {
  AdjustmentCategoryParam,
  AdjustmentTypeParam,
  PaymentStatusesParam,
  TransactionSearchOrderParam,
  TransactionTypesParam,
} from '@/utils/query/params';

export const queryParams = {
  adjustmentCategory: AdjustmentCategoryParam,
  adjustmentType: AdjustmentTypeParam,
  first: withDefault(NumberParam, 20),
  after: StringParam,
  before: StringParam,
  desc: withDefault(BooleanParam, true),
  from: DateTimeParam,
  gameRoundId: StringParam,
  maxAmount: NumberParam,
  minAmount: NumberParam,
  orderBy: withDefault(
    TransactionSearchOrderParam,
    TransactionSearchOrder.processedAt,
  ),
  paymentMethod: StringParam,
  paymentStatus: PaymentStatusesParam,
  rawId: StringParam,
  to: DateTimeParam,
  transactionTypes: TransactionTypesParam,
};
